module.exports = __webpack_public_path__ + "img/logo-horizontal-light.fa9c68ec.png";